// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-report-view {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: white;
}

.report-header {
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.report-title h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.report-date {
  font-size: 1.2rem;
  color: #666;
  text-align: center;
  margin-top: 4px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.status-badge.draft {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.status-badge.completed {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.status-badge.approved {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.edit-btn, .export-btn, .close-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
}

.edit-btn {
  background: var(--secondary-color);
  color: white;
}

.edit-btn:hover {
  background: #6a9c7a;
}

.export-btn {
  background: #007bff;
  color: white;
}

.export-btn:hover {
  background: #0056b3;
}

.close-btn {
  background: #dc3545;
  color: white;
}

.close-btn:hover {
  background: #c82333;
}

.report-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.company-info {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #333;
  padding-bottom: 20px;
}

.company-info h2 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.company-info p {
  margin: 4px 0;
  color: #666;
  font-size: 1rem;
}

.contact-info {
  margin-top: 8px;
  font-size: 1rem;
  color: #666;
}

.project-info {
  background: #f8f9fa;
  padding: 15px;
  margin-bottom: 30px;
  border-radius: 8px;
  border-left: 4px solid var(--secondary-color);
}

.project-code {
  font-weight: bold;
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 5px;
}

.project-description {
  font-size: 1rem;
  color: #555;
  margin-bottom: 5px;
}

.sent-by {
  font-size: 0.9rem;
  color: #666;
  font-style: italic;
}

.section {
  margin-bottom: 40px;
}

.section h3 {
  background: var(--secondary-color);
  color: white;
  padding: 12px 16px;
  margin: 0 0 20px 0;
  font-size: 1.1rem;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 4px 4px 0 0;
}

.table-container {
  overflow-x: auto;
  border: 1px solid #dee2e6;
  border-radius: 0 0 4px 4px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.data-table th {
  background: #f8f9fa;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  text-transform: uppercase;
}

.data-table th:last-child {
  border-right: none;
}

.data-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  color: #555;
  font-size: 0.9rem;
}

.data-table td:last-child {
  border-right: none;
}

.data-table tbody tr:hover {
  background: #f8f9fa;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.observations {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 20px;
  margin-top: -20px; /* Compensate for section h3 margin */
}

.observations p {
  margin: 8px 0;
  line-height: 1.5;
  color: #555;
}

.observations p:first-child {
  margin-top: 0;
}

.observations p:last-child {
  margin-bottom: 0;
}

.report-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  font-size: 0.9rem;
  color: #666;
}

.creation-info p {
  margin: 2px 0;
}

.powered-by {
  font-style: italic;
}

/* Print Styles */
@media print {
  .report-header {
    box-shadow: none;
    border-bottom: 2px solid #333;
  }
  
  .header-actions {
    display: none;
  }
  
  .report-content {
    padding: 20px;
  }
  
  .section {
    page-break-inside: avoid;
    margin-bottom: 30px;
  }
  
  .data-table {
    page-break-inside: avoid;
  }
  
  .data-table th {
    background: #f0f0f0 !important;
    -webkit-print-color-adjust: exact;
  }
  
  .section h3 {
    background: #333 !important;
    color: white !important;
    -webkit-print-color-adjust: exact;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
  }
  
  .header-actions {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .report-content {
    padding: 20px;
  }
  
  .company-info h2 {
    font-size: 1.4rem;
  }
  
  .report-title h1 {
    font-size: 1.2rem;
  }
  
  .table-container {
    font-size: 0.8rem;
  }
  
  .data-table th,
  .data-table td {
    padding: 6px 4px;
    font-size: 0.8rem;
  }
  
  .edit-btn, .export-btn, .close-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .report-content {
    padding: 16px;
  }
  
  .section h3 {
    font-size: 1rem;
    padding: 10px 12px;
  }
  
  .data-table th,
  .data-table td {
    padding: 4px;
    font-size: 0.75rem;
  }
  
  .observations {
    padding: 16px;
  }
  
  .report-footer {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/project/WorkReportView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;EACnC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":[".work-report-view {\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: white;\r\n}\r\n\r\n.report-header {\r\n  background: #f8f9fa;\r\n  border-bottom: 2px solid #dee2e6;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.header-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.report-title h1 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  color: #333;\r\n  text-align: center;\r\n}\r\n\r\n.report-date {\r\n  font-size: 1.2rem;\r\n  color: #666;\r\n  text-align: center;\r\n  margin-top: 4px;\r\n}\r\n\r\n.header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.status-badge {\r\n  padding: 6px 12px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.status-badge.draft {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n  border: 1px solid #ffeaa7;\r\n}\r\n\r\n.status-badge.completed {\r\n  background: #d1ecf1;\r\n  color: #0c5460;\r\n  border: 1px solid #bee5eb;\r\n}\r\n\r\n.status-badge.approved {\r\n  background: #d4edda;\r\n  color: #155724;\r\n  border: 1px solid #c3e6cb;\r\n}\r\n\r\n.edit-btn, .export-btn, .close-btn {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.edit-btn {\r\n  background: var(--secondary-color);\r\n  color: white;\r\n}\r\n\r\n.edit-btn:hover {\r\n  background: #6a9c7a;\r\n}\r\n\r\n.export-btn {\r\n  background: #007bff;\r\n  color: white;\r\n}\r\n\r\n.export-btn:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.close-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n}\r\n\r\n.close-btn:hover {\r\n  background: #c82333;\r\n}\r\n\r\n.report-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 30px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n}\r\n\r\n.company-info {\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n  border-bottom: 2px solid #333;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.company-info h2 {\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  color: #333;\r\n  margin: 0;\r\n}\r\n\r\n.company-info p {\r\n  margin: 4px 0;\r\n  color: #666;\r\n  font-size: 1rem;\r\n}\r\n\r\n.contact-info {\r\n  margin-top: 8px;\r\n  font-size: 1rem;\r\n  color: #666;\r\n}\r\n\r\n.project-info {\r\n  background: #f8f9fa;\r\n  padding: 15px;\r\n  margin-bottom: 30px;\r\n  border-radius: 8px;\r\n  border-left: 4px solid var(--secondary-color);\r\n}\r\n\r\n.project-code {\r\n  font-weight: bold;\r\n  font-size: 1.1rem;\r\n  color: #333;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.project-description {\r\n  font-size: 1rem;\r\n  color: #555;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.sent-by {\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.section {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.section h3 {\r\n  background: var(--secondary-color);\r\n  color: white;\r\n  padding: 12px 16px;\r\n  margin: 0 0 20px 0;\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  border-radius: 4px 4px 0 0;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 0 0 4px 4px;\r\n}\r\n\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: white;\r\n}\r\n\r\n.data-table th {\r\n  background: #f8f9fa;\r\n  padding: 12px 8px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n  border-bottom: 2px solid #dee2e6;\r\n  border-right: 1px solid #dee2e6;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.data-table th:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.data-table td {\r\n  padding: 10px 8px;\r\n  border-bottom: 1px solid #dee2e6;\r\n  border-right: 1px solid #dee2e6;\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.data-table td:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.data-table tbody tr:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.data-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.observations {\r\n  background: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n  padding: 20px;\r\n  margin-top: -20px; /* Compensate for section h3 margin */\r\n}\r\n\r\n.observations p {\r\n  margin: 8px 0;\r\n  line-height: 1.5;\r\n  color: #555;\r\n}\r\n\r\n.observations p:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.observations p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.report-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 40px;\r\n  padding: 20px 0;\r\n  border-top: 1px solid #dee2e6;\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n}\r\n\r\n.creation-info p {\r\n  margin: 2px 0;\r\n}\r\n\r\n.powered-by {\r\n  font-style: italic;\r\n}\r\n\r\n/* Print Styles */\r\n@media print {\r\n  .report-header {\r\n    box-shadow: none;\r\n    border-bottom: 2px solid #333;\r\n  }\r\n  \r\n  .header-actions {\r\n    display: none;\r\n  }\r\n  \r\n  .report-content {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .section {\r\n    page-break-inside: avoid;\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .data-table {\r\n    page-break-inside: avoid;\r\n  }\r\n  \r\n  .data-table th {\r\n    background: #f0f0f0 !important;\r\n    -webkit-print-color-adjust: exact;\r\n  }\r\n  \r\n  .section h3 {\r\n    background: #333 !important;\r\n    color: white !important;\r\n    -webkit-print-color-adjust: exact;\r\n  }\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .header-content {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .header-actions {\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .report-content {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .company-info h2 {\r\n    font-size: 1.4rem;\r\n  }\r\n  \r\n  .report-title h1 {\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .table-container {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 6px 4px;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .edit-btn, .export-btn, .close-btn {\r\n    padding: 6px 12px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .report-content {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .section h3 {\r\n    font-size: 1rem;\r\n    padding: 10px 12px;\r\n  }\r\n  \r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 4px;\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .observations {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .report-footer {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    text-align: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
